/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobjectGroupsMobjectTypeName
 */
export interface MobjectGroupsMobjectTypeName {
    /**
     * 
     * @type {string}
     * @memberof MobjectGroupsMobjectTypeName
     */
    name?: string | null;
}

export function MobjectGroupsMobjectTypeNameFromJSON(json: any): MobjectGroupsMobjectTypeName {
    return MobjectGroupsMobjectTypeNameFromJSONTyped(json, false);
}

export function MobjectGroupsMobjectTypeNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobjectGroupsMobjectTypeName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MobjectGroupsMobjectTypeNameToJSON(value?: MobjectGroupsMobjectTypeName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


